<template>
  <div class="container-fluid dashboard-premium">
    <!-- 센터별 입고 기간(판 #720) — 대시보드 맨 위 -->
    <div class="row pt-3">
      <div class="col-lg-12">
        <InboundDaysByCenter />
      </div>
    </div>

    <!-- AI 로켓등록 데모 GIF 섹션 - 맨 위로 이동 -->
    <div class="row demo-section">
      <div class="col-lg-12">
        <div class="demo-showcase">
          <div class="demo-video-showcase">
            <iframe
              src="https://www.youtube.com/embed/WPaMfoUUS-4?autoplay=1&loop=1&playlist=WPaMfoUUS-4&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3"
              class="demo-video-large"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
            <div class="video-overlay-large">
              <div class="play-indicator-large">
                <span class="play-icon-large">▶</span>
                <span class="play-text-large">실제 작동 영상</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- AI 로켓등록 Feature -->
    <div class="row feature-detail-section">
      <div class="col-lg-6">
        <div class="feature-detail-card">
          <div class="feature-badge">
            <span class="badge-icon">🤖</span>
            <span class="badge-text">AI 로켓등록</span>
          </div>
          <h4 class="feature-title">1688 → 쿠팡 자동등록의 혁신</h4>
          <p class="feature-description">
            단순한 닥등이 아닙니다. Gemini AI가 상품을 분석하고 최적화하여
            쿠팡에서 더 잘 팔리는 상품으로 변환합니다.
          </p>

          <div class="feature-process">
            <div class="process-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h6>1688 링크 입력</h6>
                <p>상품 링크, 특징, 타겟 키워드만 입력하면 시작</p>
              </div>
            </div>
            <div class="process-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h6>AI 분석 & 최적화</h6>
                <p>Gemini AI로 SEO, 이미지, 견적서까지 모두 자동화</p>
              </div>
            </div>
            <div class="process-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h6>이미지 자동 처리</h6>
                <p>AI가 이미지를 분석해서 자연스러운 카피라이팅으로 2중 최적화</p>
              </div>
            </div>
            <div class="process-step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h6>쿠팡 자동 등록</h6>
                <p>크롬확장프로그램으로 Supplier에 자동 등록전송</p>
              </div>
            </div>
          </div>

          <div class="feature-stats">
            <div class="stat-box">
              <div class="stat-number">92.2%</div>
              <div class="stat-label">등록 성공률</div>
            </div>
            <div class="stat-box">
              <div class="stat-number">4분</div>
              <div class="stat-label">평균 처리시간</div>
            </div>
            <div class="stat-box">
              <div class="stat-number">20개</div>
              <div class="stat-label">일일 처리한도</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="feature-visual">
          <div class="visual-container">
            <div class="flow-diagram">
              <div class="flow-item source">
                <div class="flow-icon">🏪</div>
                <div class="flow-text">1688 상품</div>
              </div>
              <div class="flow-arrow">
                <div class="arrow-line"></div>
                <div class="arrow-head"></div>
              </div>
              <div class="flow-item processor">
                <div class="flow-icon">🤖</div>
                <div class="flow-text">Gemini AI<br>분석 & 최적화</div>
              </div>
              <div class="flow-arrow">
                <div class="arrow-line"></div>
                <div class="arrow-head"></div>
              </div>
              <div class="flow-item destination">
                <div class="flow-icon">🚀</div>
                <div class="flow-text">쿠팡 로켓배송</div>
              </div>
            </div>

            <div class="ai-features">
              <div class="ai-feature">
                <span class="feature-icon">📝</span>
                <span class="feature-name">SEO 최적화</span>
              </div>
              <div class="ai-feature">
                <span class="feature-icon">🏷️</span>
                <span class="feature-name">스마트 가격책정</span>
              </div>
              <div class="ai-feature">
                <span class="feature-icon">📸</span>
                <span class="feature-name">이미지 자동처리</span>
              </div>
              <div class="ai-feature">
                <span class="feature-icon">🎯</span>
                <span class="feature-name">자동 견적서 작성</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SCM 관리 Feature -->
    <div class="row feature-detail-section">
      <div class="col-lg-6">
        <div class="feature-visual">
          <div class="visual-container">
            <div class="scm-dashboard">
              <div class="dashboard-header">
                <h6>로켓그로스 SCM 대시보드</h6>
              </div>
              <div class="dashboard-metrics">
                <div class="metric-card">
                  <div class="metric-value">1,247</div>
                  <div class="metric-label">관리 상품</div>
                </div>
                <div class="metric-card">
                  <div class="metric-value">89.4%</div>
                  <div class="metric-label">예측 정확도</div>
                </div>
                <div class="metric-card">
                  <div class="metric-value">+15%</div>
                  <div class="metric-label">수익 개선</div>
                </div>
              </div>
              <div class="chart-placeholder">
                <div class="chart-bars">
                  <div class="bar" style="height: 60%"></div>
                  <div class="bar" style="height: 80%"></div>
                  <div class="bar" style="height: 45%"></div>
                  <div class="bar" style="height: 90%"></div>
                  <div class="bar" style="height: 70%"></div>
                </div>
                <div class="chart-label">판매량 예측 차트</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="feature-detail-card">
          <div class="feature-badge">
            <span class="badge-icon">📊</span>
            <span class="badge-text">SCM 관리</span>
          </div>
          <h4 class="feature-title">AI 기반 스마트 공급망 관리</h4>
          <p class="feature-description">
            단순한 재고 관리를 넘어서 AI가 판매 패턴을 분석하고 최적의 구매 시점과
            수량을 추천하는 지능형 SCM 시스템입니다.
          </p>

          <div class="feature-benefits">
            <div class="benefit-item">
              <div class="benefit-icon">🎯</div>
              <div class="benefit-content">
                <h6>정확한 수요 예측</h6>
                <p>과거 판매 데이터와 시장 트렌드를 분석하여 89.4% 정확도로 수요 예측</p>
              </div>
            </div>
            <div class="benefit-item">
              <div class="benefit-icon">💰</div>
              <div class="benefit-content">
                <h6>재고 비용 최적화</h6>
                <p>과재고 방지와 품절 최소화로 평균 15% 수익성 개선</p>
              </div>
            </div>
            <div class="benefit-item">
              <div class="benefit-icon">⚡</div>
              <div class="benefit-content">
                <h6>자동 발주 알림</h6>
                <p>안전재고 기준 도달 시 자동 알림 및 최적 발주량 추천</p>
              </div>
            </div>
            <div class="benefit-item">
              <div class="benefit-icon">📈</div>
              <div class="benefit-content">
                <h6>실시간 수익 분석</h6>
                <p>상품별 수익성 분석과 차트로 한눈에 보는 비즈니스 인사이트</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 키워드 분석 Feature -->
    <div class="row feature-detail-section">
      <div class="col-lg-6">
        <div class="feature-detail-card">
          <div class="feature-badge">
            <span class="badge-icon">🔍</span>
            <span class="badge-text">키워드 분석</span>
          </div>
          <h4 class="feature-title">10만+ 키워드 실시간 모니터링</h4>
          <p class="feature-description">
            쿠팡 검색 트렌드를 실시간으로 추적하고 경쟁상품의 랭킹 변동을 모니터링하여
            데이터 기반의 마케팅 전략을 수립할 수 있습니다.
          </p>

          <div class="keyword-features">
            <div class="keyword-feature">
              <div class="feature-header">
                <span class="feature-icon">📊</span>
                <h6>실시간 랭킹 추적</h6>
              </div>
              <p>타겟 키워드의 검색 순위 변동을 실시간으로 모니터링</p>
              <div class="feature-highlight">100,000+ 키워드 동시 추적</div>
            </div>

            <div class="keyword-feature">
              <div class="feature-header">
                <span class="feature-icon">🎯</span>
                <h6>경쟁상품 분석</h6>
              </div>
              <p>경쟁업체의 상품 순위 변동과 마케팅 전략 분석</p>
              <div class="feature-highlight">98.7% 분석 정확도</div>
            </div>

            <div class="keyword-feature">
              <div class="feature-header">
                <span class="feature-icon">📈</span>
                <h6>트렌드 예측</h6>
              </div>
              <p>검색량 변화 패턴 분석으로 시장 트렌드 예측</p>
              <div class="feature-highlight">실시간 업데이트</div>
            </div>
          </div>

          <div class="keyword-benefits">
            <div class="benefit-tag">검색 최적화</div>
            <div class="benefit-tag">경쟁 분석</div>
            <div class="benefit-tag">시장 인사이트</div>
            <div class="benefit-tag">매출 증대</div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="feature-visual">
          <div class="visual-container">
            <div class="keyword-dashboard">
              <div class="dashboard-header">
                <h6>키워드 분석 대시보드</h6>
                <div class="live-indicator">
                  <span class="live-dot"></span>
                  <span class="live-text">LIVE</span>
                </div>
              </div>

              <div class="keyword-list">
                <div class="keyword-item">
                  <div class="keyword-info">
                    <span class="keyword-name">무선 이어폰</span>
                    <span class="keyword-rank">#3</span>
                  </div>
                  <div class="keyword-trend up">
                    <span class="trend-arrow">↗</span>
                    <span class="trend-value">+2</span>
                  </div>
                </div>

                <div class="keyword-item">
                  <div class="keyword-info">
                    <span class="keyword-name">블루투스 스피커</span>
                    <span class="keyword-rank">#7</span>
                  </div>
                  <div class="keyword-trend down">
                    <span class="trend-arrow">↘</span>
                    <span class="trend-value">-1</span>
                  </div>
                </div>

                <div class="keyword-item">
                  <div class="keyword-info">
                    <span class="keyword-name">스마트워치</span>
                    <span class="keyword-rank">#12</span>
                  </div>
                  <div class="keyword-trend stable">
                    <span class="trend-arrow">→</span>
                    <span class="trend-value">0</span>
                  </div>
                </div>
              </div>

              <div class="analytics-chart">
                <div class="chart-title">검색량 트렌드</div>
                <div class="trend-line">
                  <svg width="100%" height="60" viewBox="0 0 300 60">
                    <polyline points="0,50 50,30 100,20 150,35 200,15 250,25 300,10"
                              fill="none" stroke="#00d4ff" stroke-width="2"/>
                    <circle cx="300" cy="10" r="3" fill="#00d4ff"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Core Services -->
    <div class="row tech-section">
      <div class="col-lg-6">
        <div class="tech-card rocket-delivery">
          <div class="tech-icon">
            <div class="service-animation">
              <div class="rocket-icon">🚀</div>
            </div>
          </div>
          <h4 class="tech-title">로켓배송 통합관리</h4>
          <p class="tech-description">
            쿠팡 로켓배송 상품의 전체 라이프사이클 관리<br>
            <span class="tech-spec">• AI상품등록: 1688→쿠팡 자동등록 (95.2% 성공률)</span><br>
            <span class="tech-spec">• 상품관리: 50,000+ 상품DB 통합관리</span><br>
            <span class="tech-spec">• 발주리스트: 스마트 재고관리 & 자동발주</span><br>
            <span class="tech-spec">• 판매현황: 실시간 매출분석 & 수익최적화</span>
          </p>
          <div class="tech-status">
            <span class="status-dot active"></span>
            <span class="status-text">운영중</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="tech-card rocket-growth">
          <div class="tech-icon">
            <div class="service-animation">
              <div class="growth-icon">📈</div>
            </div>
          </div>
          <h4 class="tech-title">로켓그로스 SCM</h4>
          <p class="tech-description">
            로켓그로스 전용 공급망 관리 시스템<br>
            <span class="tech-spec">• 상품관리: 로켓그로스 상품DB 수집 & 매입가 관리</span><br>
            <span class="tech-spec">• SCM관리: AI 기반 구매예측 & 재고최적화</span><br>
            <span class="tech-spec">• 수익분석: 실시간 수익성 분석 & 차트 시각화</span><br>
            <span class="tech-spec">• 자동구매: 안전재고 기반 스마트 발주시스템</span>
          </p>
          <div class="tech-status">
            <span class="status-dot processing"></span>
            <span class="status-text">확장중</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Services -->
    <div class="row tech-section">
      <div class="col-lg-4">
        <div class="tech-card analytics">
          <div class="tech-icon">
            <div class="service-animation">
              <div class="analytics-icon">📊</div>
            </div>
          </div>
          <h4 class="tech-title">판매/분석 도구</h4>
          <p class="tech-description">
            데이터 기반 의사결정 지원<br>
            <span class="tech-spec">• 키워드분석: 10만+ 키워드 실시간 추적</span><br>
            <span class="tech-spec">• 랭킹추적: 경쟁상품 모니터링</span><br>
            <span class="tech-spec">• 트렌드분석: 시장동향 예측</span>
          </p>
          <div class="tech-status">
            <span class="status-dot active"></span>
            <span class="status-text">운영중</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="tech-card coupass">
          <div class="tech-icon">
            <div class="service-animation">
              <div class="coupass-icon">🛒</div>
            </div>
          </div>
          <h4 class="tech-title">쿠패스 구매대행</h4>
          <p class="tech-description">
            구매부터 쿠팡입고까지 완전자동화<br>
            <span class="tech-spec">• 자동소싱: 1688 상품 자동발굴</span><br>
            <span class="tech-spec">• 품질검수: 전문 QC 시스템</span><br>
            <span class="tech-spec">• 입고대행: 구매부터 입고까지 평균 17일 (1688 판매자 상황에 따라 달라짐)</span>
          </p>
          <div class="tech-status">
            <span class="status-dot secure"></span>
            <span class="status-text">안정운영</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="tech-card ai-assistant">
          <div class="tech-icon">
            <div class="service-animation">
              <div class="ai-icon">🤖</div>
            </div>
          </div>
          <h4 class="tech-title">AI 어시스턴트, 튜터</h4>
          <p class="tech-description blur-content">
            AI기반 어시스턴트, 튜터<br>
            <span class="tech-spec blur-text">• ████████████████</span><br>
            <span class="tech-spec blur-text">• ████████████████</span><br>
            <span class="tech-spec blur-text">• ████████████████</span>
          </p>
          <div class="tech-status">
            <span class="status-dot processing"></span>
            <span class="status-text">개발중</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Intelligence Modules -->
    <div class="row intelligence-section">
      <div class="col-lg-8">
        <div class="intelligence-card">
          <div class="card-header-custom">
            <h4 class="intelligence-title">
              <span class="title-icon">⚡</span>
              핵심 비즈니스 모듈
            </h4>
            <div class="classification-badge">
              <span class="classification">PREMIUM</span>
            </div>
          </div>
          <div class="intelligence-grid">
            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">RKT-AI</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">로켓배송 AI상품등록</h5>
              <p class="item-description">1688 상품링크 입력만으로 쿠팡 자동등록. Gemini AI 기반 SEO최적화, 이미지처리, 가격책정 자동화</p>
              <div class="item-metrics">
                <span class="metric">처리속도: 평균 3분/상품</span>
                <span class="metric">등록성공률: 95.2%</span>
                <span class="metric">일일처리: 최대 20개</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">RKT-DB</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">로켓배송 상품관리</h5>
              <p class="item-description">50,000+ 상품DB 통합관리. 바코드검색, 옵션관리, 매입가추적, 엑셀 일괄업로드 지원</p>
              <div class="item-metrics">
                <span class="metric">관리상품: 50,000+</span>
                <span class="metric">검색속도: 0.1초</span>
                <span class="metric">동기화: 실시간</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">RKT-PO</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">로켓배송 발주리스트</h5>
              <p class="item-description">판매데이터 기반 스마트 재고관리. 안전재고 알림, 자동발주 추천, 배송추적 통합관리</p>
              <div class="item-metrics">
                <span class="metric">발주정확도: 94.7%</span>
                <span class="metric">재고최적화: 87%</span>
                <span class="metric">배송추적: 실시간</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">RKT-SLS</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">로켓배송 판매현황</h5>
              <p class="item-description">실시간 매출분석 & 수익성 모니터링. 크롬확장프로그램으로 쿠팡 판매데이터 자동수집</p>
              <div class="item-metrics">
                <span class="metric">수집속도: 0.2초/SKU</span>
                <span class="metric">분석정확도: 99.1%</span>
                <span class="metric">업데이트: 24시간</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">GRW-DB</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">로켓그로스 상품관리</h5>
              <p class="item-description">로켓그로스 상품DB 수집 & 구매정보 매칭. 1688 옵션매칭, 매입가 관리, 통관정보 입력</p>
              <div class="item-metrics">
                <span class="metric">수집상품: 로켓그로스 전체</span>
                <span class="metric">매칭정확도: 92.3%</span>
                <span class="metric">업데이트: 일 1회</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">GRW-SCM</span>
                <span class="item-status development">확장중</span>
              </div>
              <h5 class="item-title">로켓그로스 SCM관리</h5>
              <p class="item-description">AI 기반 구매예측 & 재고최적화. 판매데이터 분석으로 구매필요수량 자동계산, 수익성 차트</p>
              <div class="item-metrics">
                <span class="metric">예측정확도: 89.4%</span>
                <span class="metric">재고효율: +23%</span>
                <span class="metric">수익개선: +15%</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">KW-ANL</span>
                <span class="item-status operational">운영중</span>
              </div>
              <h5 class="item-title">키워드분석 & 랭킹추적</h5>
              <p class="item-description">10만+ 키워드 실시간 추적. 경쟁상품 모니터링, 트렌드 분석, 검색순위 변동 알림</p>
              <div class="item-metrics">
                <span class="metric">추적키워드: 100,000+</span>
                <span class="metric">업데이트: 실시간</span>
                <span class="metric">정확도: 98.7%</span>
              </div>
            </div>

            <div class="intelligence-item">
              <div class="item-header">
                <span class="item-code">CP-BUY</span>
                <span class="item-status secure">안정운영</span>
              </div>
              <h5 class="item-title">쿠패스 구매대행</h5>
              <p class="item-description">구매부터 쿠팡입고까지 완전자동화. 1688 소싱→품질검수→배송→통관→쿠팡입고 원스톱</p>
              <div class="item-metrics">
                <span class="metric">처리시간: 구매부터 입고까지 평균 17일</span>
                <span class="metric">성공률: 98.5%</span>
                <span class="metric">1688 판매자 상황에 따라 달라짐</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-4">
        <div class="performance-card">
          <div class="performance-header">
            <h4 class="performance-title">
              <span class="title-icon">📈</span>
              실시간 운영 현황
            </h4>
          </div>
          <div class="performance-metrics">
            <div class="metric-item">
              <div class="metric-label">AI 상품등록 성공률</div>
              <div class="metric-bar">
                <div class="metric-fill" style="width: 95%"></div>
              </div>
              <div class="metric-value">95.2%</div>
            </div>

            <div class="metric-item">
              <div class="metric-label">키워드 분석 정확도</div>
              <div class="metric-bar">
                <div class="metric-fill quantum" style="width: 99%"></div>
              </div>
              <div class="metric-value">98.7%</div>
            </div>

            <div class="metric-item">
              <div class="metric-label">쿠패스 구매대행 성공률</div>
              <div class="metric-bar">
                <div class="metric-fill data" style="width: 98%"></div>
              </div>
              <div class="metric-value">98.5%</div>
            </div>

            <div class="metric-item">
              <div class="metric-label">로켓그로스 SCM 효율성</div>
              <div class="metric-bar">
                <div class="metric-fill security" style="width: 89%"></div>
              </div>
              <div class="metric-value">89.4%</div>
            </div>
          </div>

          <div class="system-status">
            <div class="status-header">서비스 상태</div>
            <div class="status-items">
              <div class="status-item">
                <span class="status-indicator online"></span>
                <span class="status-text">모든 서비스 정상 운영</span>
              </div>
              <div class="status-item">
                <span class="status-indicator processing"></span>
                <span class="status-text">Gemini AI 엔진 활성화</span>
              </div>
              <div class="status-item">
                <span class="status-indicator secure"></span>
                <span class="status-text">크롬확장프로그램 연동</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Access Portal -->
    <div class="row access-section">
      <div class="col-lg-12">
        <div class="access-portal">
          <div class="portal-header">
            <h4 class="portal-title">
              <span class="title-icon">🚀</span>
              서비스 접근 포털
            </h4>
            <div class="clearance-level">
              <span class="clearance-text">사용자 등급: </span>
              <span class="clearance-value">프리미엄</span>
            </div>
          </div>

          <div class="portal-grid">
            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">🚀</span>
                <span class="module-name">로켓배송 AI상품등록</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">1688 링크만으로 쿠팡 자동등록. Gemini AI 기반 SEO최적화</p>
              <div class="module-stats">
                <span class="stat">일일한도: 20개</span>
                <span class="stat">성공률: 95.2%</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">📋</span>
                <span class="module-name">로켓배송 상품관리</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">50,000+ 상품DB 통합관리. 바코드검색, 매입가추적</p>
              <div class="module-stats">
                <span class="stat">관리상품: 50,000+</span>
                <span class="stat">검색속도: 0.1초</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">📦</span>
                <span class="module-name">로켓배송 발주리스트</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">스마트 재고관리 & 자동발주. 배송추적 통합관리</p>
              <div class="module-stats">
                <span class="stat">발주정확도: 94.7%</span>
                <span class="stat">재고최적화: 87%</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">📈</span>
                <span class="module-name">로켓배송 판매현황</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">매일 재고,입고 수집. 크롬확장프로그램으로 데이터 자동수집</p>
              <div class="module-stats">
                <span class="stat">수집속도: 0.2초/SKU</span>
                <span class="stat">분석정확도: 99.1%</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">🏆</span>
                <span class="module-name">로켓그로스 상품관리</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">로켓그로스 상품DB 수집 & 1688 옵션매칭, 매입가 관리</p>
              <div class="module-stats">
                <span class="stat">수집상품: 로켓그로스 전체</span>
                <span class="stat">매칭정확도: 92.3%</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">⚡</span>
                <span class="module-name">로켓그로스 SCM관리</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">AI 기반 구매예측 & 재고최적화. 수익성 차트 분석</p>
              <div class="module-stats">
                <span class="stat">예측정확도: 89.4%</span>
                <span class="stat">수익개선: +15%</span>
              </div>
            </div>

            <div class="portal-module">
              <div class="module-header">
                <span class="module-icon">🔍</span>
                <span class="module-name">키워드분석 & 랭킹추적</span>
                <span class="access-indicator granted">이용가능</span>
              </div>
              <p class="module-description">10만+ 키워드 실시간 추적. 경쟁상품 모니터링</p>
              <div class="module-stats">
                <span class="stat">추적키워드: 100,000+</span>
                <span class="stat">업데이트: 실시간</span>
              </div>
            </div>

            <div class="portal-module classified">
              <div class="module-header">
                <span class="module-icon">🛒</span>
                <span class="module-name">쿠패스 구매대행</span>
                <span class="access-indicator restricted">별도신청</span>
              </div>
              <p class="module-description">구매부터 쿠팡입고까지 완전자동화. 1688→품질검수→입고</p>
              <div class="module-stats">
                <span class="stat">처리시간: 구매부터 입고까지 평균 17일</span>
                <span class="stat">성공률: 98.5%</span>
              </div>
            </div>
          </div>

          <div class="portal-footer">
            <div class="footer-text">
              좌측 메뉴에서 원하는 서비스를 선택하여 이용하실 수 있습니다.
              <span class="warning-text">문의사항은 고객지원팀으로 연락주세요.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InboundDaysByCenter from '@/components/growth/InboundDaysByCenter.vue'

export default {
  name: 'Dashboard1',
  components: { InboundDaysByCenter },
  data() {
    return {
      // 간단한 데이터만 유지
    }
  },
  mounted() {
    // 다크 테마 기능 제거됨
  },
  methods: {
    // 다크 테마 관련 메서드 모두 제거됨

  }
}
</script>

<style scoped>
/* Dashboard Premium Styles */
.dashboard-premium {
  background: linear-gradient(135deg, #0c0c0c 0%, #1a1a2e 50%, #16213e 100%);
  min-height: 100vh;
  color: #ffffff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.badge-text {
  background: linear-gradient(45deg, #00d4ff, #007bff);
  color: #000;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 900;
  color: #00d4ff;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  color: #a0a0a0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Tech Section */
.tech-section {
  padding: 40px 0;
}

.tech-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 30px;
  margin-bottom: 30px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00d4ff, transparent);
}

.tech-card:hover {
  transform: translateY(-5px);
  border-color: rgba(0, 212, 255, 0.3);
  box-shadow: 0 20px 40px rgba(0, 212, 255, 0.1);
}

.tech-icon {
  height: 80px;
  margin-bottom: 20px;
  position: relative;
}

.neural-animation, .quantum-animation, .blockchain-animation {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tech-title {
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.tech-description {
  color: #cccccc;
  line-height: 1.6;
  margin-bottom: 20px;
}

.tech-spec {
  color: #00d4ff;
  font-size: 0.9rem;
  display: block;
  margin: 5px 0;
}

.tech-status {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-dot.active {
  background: #00ff88;
}

.status-dot.processing {
  background: #ffaa00;
}

.status-dot.secure {
  background: #007bff;
}

.status-text {
  font-size: 0.8rem;
  color: #a0a0a0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Intelligence Section */
.intelligence-section {
  padding: 40px 0;
}

.intelligence-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 30px;
  backdrop-filter: blur(15px);
  position: relative;
  overflow: hidden;
}

.intelligence-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ff0080, #00d4ff, #ff0080);
  animation: glow 3s ease-in-out infinite alternate;
}

.card-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.intelligence-title {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.title-icon {
  margin-right: 10px;
}

.classification-badge {
  background: rgba(255, 0, 128, 0.2);
  border: 1px solid #ff0080;
  border-radius: 15px;
  padding: 5px 15px;
}

.classification {
  color: #ff0080;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 2px;
}

.intelligence-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.intelligence-item {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.intelligence-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(0, 212, 255, 0.3);
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.item-code {
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 700;
  font-family: 'Courier New', monospace;
}

.item-status {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.item-status.operational {
  background: rgba(0, 255, 136, 0.2);
  color: #00ff88;
}

.item-status.experimental {
  background: rgba(255, 170, 0, 0.2);
  color: #ffaa00;
}

.item-status.development {
  background: rgba(0, 123, 255, 0.2);
  color: #007bff;
}

.item-status.secure {
  background: rgba(111, 66, 193, 0.2);
  color: #6f42c1;
}

.item-title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.item-description {
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 15px;
  line-height: 1.5;
}

.item-metrics {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.metric {
  background: rgba(255, 255, 255, 0.05);
  color: #a0a0a0;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
}

/* Performance Card */
.performance-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 30px;
  backdrop-filter: blur(15px);
  height: fit-content;
}

.performance-header {
  margin-bottom: 30px;
}

.performance-title {
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.performance-metrics {
  margin-bottom: 30px;
}

.metric-item {
  margin-bottom: 20px;
}

.metric-label {
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 8px;
}

.metric-bar {
  background: rgba(255, 255, 255, 0.1);
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 5px;
}

.metric-fill {
  height: 100%;
  background: linear-gradient(90deg, #00d4ff, #007bff);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.metric-fill.quantum {
  background: linear-gradient(90deg, #ff0080, #ff4081);
}

.metric-fill.data {
  background: linear-gradient(90deg, #00ff88, #00e676);
}

.metric-fill.security {
  background: linear-gradient(90deg, #6f42c1, #9c27b0);
}

.metric-value {
  color: #00d4ff;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: right;
}

.system-status {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
}

.status-header {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.status-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-indicator.online {
  background: #00ff88;
}

.status-indicator.processing {
  background: #ffaa00;
}

.status-indicator.secure {
  background: #6f42c1;
}

.status-text {
  color: #cccccc;
  font-size: 0.9rem;
}

@keyframes glow {
  0% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* Access Portal */
.access-section {
  padding: 40px 0;
}

.access-portal {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.01) 100%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 25px;
  padding: 40px;
  backdrop-filter: blur(20px);
  position: relative;
  overflow: hidden;
}

.access-portal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, #00d4ff, #ff0080, #00d4ff, transparent);
  animation: scan 4s linear infinite;
}

.portal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.portal-title {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 800;
  margin: 0;
}

.clearance-level {
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid #00ff88;
  border-radius: 20px;
  padding: 8px 20px;
}

.clearance-text {
  color: #a0a0a0;
  font-size: 0.8rem;
  font-weight: 600;
}

.clearance-value {
  color: #00ff88;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.portal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.portal-module {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 15px;
  padding: 25px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.portal-module::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00d4ff, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.portal-module:hover::before {
  opacity: 1;
}

.portal-module:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(0, 212, 255, 0.3);
  transform: translateY(-3px);
}

.portal-module.classified {
  border-color: rgba(255, 0, 128, 0.3);
  background: rgba(255, 0, 128, 0.02);
}

.portal-module.classified::before {
  background: linear-gradient(90deg, transparent, #ff0080, transparent);
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.module-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

.module-name {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1;
}

.access-indicator {
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.access-indicator.granted {
  background: rgba(0, 255, 136, 0.2);
  color: #00ff88;
  border: 1px solid #00ff88;
}

.access-indicator.restricted {
  background: rgba(255, 0, 128, 0.2);
  color: #ff0080;
  border: 1px solid #ff0080;
}

.module-description {
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 15px;
}

.module-stats {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.stat {
  background: rgba(255, 255, 255, 0.05);
  color: #a0a0a0;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
}

.portal-footer {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-text {
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.5;
}

.warning-text {
  color: #ff0080;
  font-weight: 600;
}

@keyframes scan {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Blur Effects for Development Content */
.blur-content {
  position: relative;
}

.blur-text {
  filter: blur(3px);
  user-select: none;
  pointer-events: none;
}

.blur-text::selection {
  background: transparent;
}

/* Feature Showcase Section */
.feature-showcase-section {
  padding: 60px 0 40px 0;
  margin-top: 40px;
}

.showcase-header {
  margin-bottom: 60px;
}

.showcase-title {
  color: #ffffff;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
}

.showcase-subtitle {
  color: #a0a0a0;
  font-size: 1.2rem;
  margin-bottom: 0;
}

/* Feature Detail Section */
.feature-detail-section {
  padding: 40px 0;
  margin-bottom: 40px;
}

.feature-detail-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
  height: 100%;
  backdrop-filter: blur(15px);
}

.feature-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(45deg, #00d4ff, #007bff);
  color: #000;
  padding: 8px 20px;
  border-radius: 25px;
  font-weight: 700;
  margin-bottom: 20px;
}

.badge-icon {
  margin-right: 8px;
  font-size: 1.2rem;
}

.feature-title {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.3;
}

.feature-description {
  color: #cccccc;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

/* Process Steps */
.feature-process {
  margin-bottom: 30px;
}

.process-step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border-left: 3px solid #00d4ff;
}

.step-number {
  background: linear-gradient(45deg, #00d4ff, #007bff);
  color: #000;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 15px;
  flex-shrink: 0;
}

.step-content h6 {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 5px;
}

.step-content p {
  color: #a0a0a0;
  margin: 0;
  font-size: 0.9rem;
}

/* Feature Stats */
.feature-stats {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.stat-box {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  flex: 1;
}

.stat-box .stat-number {
  color: #00d4ff;
  font-size: 1.8rem;
  font-weight: 900;
  margin-bottom: 5px;
}

.stat-box .stat-label {
  color: #a0a0a0;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Feature Visual */
.feature-visual {
  display: flex;
  align-items: center;
  height: 100%;
}

.visual-container {
  width: 100%;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 30px;
  backdrop-filter: blur(10px);
}

/* Demo Section */
.demo-section {
  margin: 30px 0 60px 0;
  padding: 0 15px;
}

.demo-showcase {
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}

.demo-header {
  margin-bottom: 40px;
}

.demo-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.demo-icon {
  font-size: 2.8rem;
  animation: pulse 2s infinite;
}

.demo-subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 0;
}

.demo-gif-showcase,
.demo-video-showcase {
  position: relative;
  display: inline-block;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 212, 255, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.demo-gif-showcase:hover,
.demo-video-showcase:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 80px rgba(0, 212, 255, 0.4);
}

.demo-gif-large,
.demo-video-large {
  width: 100%;
  max-width: 800px;
  height: auto;
  display: block;
  border-radius: 20px;
}

.demo-video-large {
  aspect-ratio: 16/9;
  height: 450px;
}

.gif-overlay-large,
.video-overlay-large {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 20px;
  padding: 6px 12px;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.play-indicator-large {
  display: flex;
  align-items: center;
  gap: 6px;
}

.play-icon-large {
  color: #00d4ff;
  font-size: 10px;
  animation: pulse 2s infinite;
}

.play-text-large {
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

/* Demo GIF */
.demo-gif-container {
  position: relative;
  margin-bottom: 30px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 212, 255, 0.2);
}

.demo-gif {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
}

.gif-overlay {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  padding: 8px 15px;
  backdrop-filter: blur(10px);
}

.play-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.play-icon {
  color: #00d4ff;
  font-size: 0.9rem;
}

.play-text {
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 600;
}

/* Flow Diagram */
.flow-diagram {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.flow-item {
  text-align: center;
  flex: 1;
}

.flow-icon {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.flow-text {
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.3;
}

.flow-arrow {
  position: relative;
  width: 40px;
  height: 2px;
  margin: 0 10px;
}

.arrow-line {
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #00d4ff, #007bff);
}

.arrow-head {
  position: absolute;
  right: -5px;
  top: -3px;
  width: 0;
  height: 0;
  border-left: 8px solid #007bff;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

/* AI Features */
.ai-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.ai-feature {
  display: flex;
  align-items: center;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  padding: 12px;
}

.ai-feature .feature-icon {
  margin-right: 10px;
  font-size: 1.2rem;
}

.ai-feature .feature-name {
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
}

/* SCM Dashboard */
.scm-dashboard {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 20px;
}

.dashboard-header h6 {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
}

.dashboard-metrics {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
}

.metric-card {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  flex: 1;
}

.metric-card .metric-value {
  color: #00d4ff;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 5px;
}

.metric-card .metric-label {
  color: #a0a0a0;
  font-size: 0.8rem;
}

.chart-placeholder {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}

.chart-bars {
  display: flex;
  align-items: end;
  justify-content: space-around;
  height: 60px;
  margin-bottom: 10px;
}

.bar {
  width: 12px;
  background: linear-gradient(to top, #007bff, #00d4ff);
  border-radius: 2px;
  animation: barGrow 1s ease-out;
}

.chart-label {
  color: #a0a0a0;
  font-size: 0.8rem;
}

@keyframes barGrow {
  from { height: 0; }
  to { height: var(--height); }
}

/* Benefits */
.feature-benefits {
  margin-top: 30px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
  border-left: 3px solid #00ff88;
}

.benefit-icon {
  font-size: 1.5rem;
  margin-right: 15px;
  margin-top: 5px;
}

.benefit-content h6 {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 8px;
}

.benefit-content p {
  color: #a0a0a0;
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}

/* Keyword Features */
.keyword-features {
  margin-top: 30px;
}

.keyword-feature {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.keyword-feature .feature-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.keyword-feature .feature-header .feature-icon {
  margin-right: 10px;
  font-size: 1.3rem;
}

.keyword-feature .feature-header h6 {
  color: #ffffff;
  font-weight: 600;
  margin: 0;
}

.keyword-feature p {
  color: #a0a0a0;
  margin-bottom: 10px;
  line-height: 1.4;
}

.feature-highlight {
  background: linear-gradient(45deg, #00d4ff, #007bff);
  color: #000;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 700;
  display: inline-block;
}

.keyword-benefits {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 25px;
}

.benefit-tag {
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  color: #00ff88;
  padding: 6px 15px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

/* Keyword Dashboard */
.keyword-dashboard {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 20px;
}

.keyword-dashboard .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.keyword-dashboard .dashboard-header h6 {
  color: #ffffff;
  font-weight: 600;
  margin: 0;
}

.live-indicator {
  display: flex;
  align-items: center;
  gap: 5px;
}

.live-dot {
  width: 8px;
  height: 8px;
  background: #ff0080;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.live-text {
  color: #ff0080;
  font-size: 0.8rem;
  font-weight: 700;
}

.keyword-list {
  margin-bottom: 25px;
}

.keyword-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 10px;
}

.keyword-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.keyword-name {
  color: #ffffff;
  font-weight: 500;
}

.keyword-rank {
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 700;
}

.keyword-trend {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: 600;
}

.keyword-trend.up {
  color: #00ff88;
}

.keyword-trend.down {
  color: #ff4757;
}

.keyword-trend.stable {
  color: #a0a0a0;
}

.analytics-chart {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 15px;
}

.chart-title {
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}

.trend-line {
  height: 60px;
  display: flex;
  align-items: center;
}

/* 다크 테마 기능 제거됨 */
/* 모든 다크 테마 CSS 제거됨 */

/* Responsive Design */
@media (max-width: 768px) {
  .tech-card, .intelligence-card, .performance-card, .access-portal {
    margin-bottom: 20px;
  }

  .portal-grid {
    grid-template-columns: 1fr;
  }

  .feature-stats {
    flex-direction: column;
  }

  .flow-diagram {
    flex-direction: column;
    gap: 20px;
  }

  .flow-arrow {
    transform: rotate(90deg);
  }

  .dashboard-metrics {
    flex-direction: column;
  }

  .ai-features {
    grid-template-columns: 1fr;
  }

  /* Demo Section 반응형 */
  .demo-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 10px;
  }

  .demo-icon {
    font-size: 2.2rem;
  }

  .demo-subtitle {
    font-size: 1rem;
  }

  .demo-gif-large {
    max-width: 100%;
  }

  .gif-overlay-large {
    top: 10px;
    right: 10px;
    padding: 5px 10px;
  }

  .play-text-large {
    font-size: 9px;
  }

  .play-icon-large {
    font-size: 8px;
  }
}
</style>
